import React, { useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import PageTop from "../../components/PageTop/PageTop";
import PrivacyAndPolicy from "../../components/PrivacyAndPolicy/PrivacyAndPolicy";
import MainNav from "../../shared/MainNav/MainNav";

export default function Privacy() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <>
      <MainNav title="Privacy And Policy" />
      <PageTop pageTitle="Privacy And Policy" />
      <PrivacyAndPolicy />
      <Footer />
    </>
  );
}
